"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _superagent2 = _interopRequireDefault(require("superagent"));
var _getSearchUrl = _interopRequireDefault(require("../getSearchUrl"));
var sendCategorySearchRequest = function sendCategorySearchRequest(_ref) {
  var query = _ref.query,
    lang = _ref.lang;
  return _superagent2["default"].get((0, _getSearchUrl["default"])({
    url: "/categories/list",
    query: query,
    lang: lang,
    pageSize: 10,
    currentPage: 1,
    productSearch: false
  })).withCredentials().then(function (res) {
    return res.body;
  });
};
var _default = sendCategorySearchRequest;
exports["default"] = _default;